import { FC } from 'react';
import { Modal, ModalProps, Typography } from 'antd';
import { ProcBasicForm } from './ProcBasicForm';

const { Title } = Typography;

export const CreateProcModal: FC<ModalProps> = ({ open, afterClose }) => {
  return (
    <Modal
      data-testid="create-proc-basic-info-modal"
      title={
        <Title
          level={2}
          style={{ fontWeight: 300, lineHeight: 1, padding: '30px 0 0 0' }}
        >
          Let's add basic info for <br />
          your <strong>new proc</strong>!
        </Title>
      }
      open={open}
      footer={null}
      style={{ maxWidth: '90%', width: 450 }}
      onCancel={() => afterClose && afterClose()}
    >
      <ProcBasicForm
        onSubmit={() => afterClose && afterClose()}
        onCancel={() => afterClose && afterClose()}
      />
    </Modal>
  );
};
